var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.10059 12H21.8996","stroke":"#07162C","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M12 2.10059V21.8996","stroke":"#07162C","strokeWidth":"2","key":1})]);
}

Plus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
